<template>
  <div />
</template>

<script setup>
const { $i18n } = useNuxtApp()

useJsonld(() => ({
  '@context': 'http://schema.org',
  '@type': 'Organization',
  url: 'https://www.myfunnow.com/',
  logo: 'https://www.myfunnow.com/images/logo/logo.svg',
  name: `${$i18n.t('funnow_title')}`,
  sameAs: ['https://www.facebook.com/funnowtaiwan/', 'https://www.instagram.com/funnow.tw/'],
  contactPoint: [
    {
      '@type': 'ContactPoint',
      areaServed: 'TW',
      telephone: '+886-965-385-825',
      contactType: 'customer service',
      availableLanguage: ['Chinese', 'English'],
    },
    {
      '@type': 'ContactPoint',
      areaServed: 'HK',
      telephone: '+852-9688-2148',
      contactType: 'customer service',
    },
    {
      '@type': 'ContactPoint',
      areaServed: 'JP',
      telephone: '+81-80-1115-7641',
      contactType: 'customer service',
    },
    {
      '@type': 'ContactPoint',
      areaServed: 'MY',
      telephone: '+6016-477-6234',
      contactType: 'customer service',
    },
  ],
}))
</script>
